import { CookiesService } from '../cookies/cookies.service';
import { ApiService } from '../api/api.service';
import { API_URL } from '../pcs-api/pcs-api.service';
export const AUTH_TOKEN_COOKIE = 'platform_token';
export const API_BASE = `${API_URL}users/`;
export class AuthenticationService {
    constructor(_cookieService = new CookiesService()) {
        this._cookieService = _cookieService;
        this.getToken = () => {
            return this._cookieService.getCookie(AUTH_TOKEN_COOKIE);
        };
        this.setToken = (token, keepLogin) => {
            const cookieOptions = {};
            if (!keepLogin) {
                cookieOptions['expires'] = 1;
            }
            this._cookieService.setCookie(AUTH_TOKEN_COOKIE, token, cookieOptions);
        };
        this.signIn = async (login, password, keepLogin) => {
            const { data } = await this._apiService.post('/sign_in', {
                user: {
                    email: login,
                    password
                }
            });
            const token = data['spree_api_key'];
            this.setToken(token, keepLogin);
            return token;
        };
        this.signOut = async () => {
            await this._apiService.get('/sign_out', {
                headers: {
                    'X-Spree-Token': this.getToken()
                }
            });
            this._cookieService.removeCookie(AUTH_TOKEN_COOKIE);
            return true;
        };
        this._apiService = new ApiService({
            baseURL: API_BASE
        });
    }
}
//# sourceMappingURL=authentication.service.js.map